import { useMemo } from 'react'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select'
import { Textarea } from '@/components/ui/textarea'
import type {
  IntegrationNodeData,
  HttpMethod,
} from '../../../../nodes/integration-node/integration.node'
import type { BuilderNodeType } from '../../../../types'

type IntegrationPropertyPanelProps = Readonly<{
  id: string
  type: BuilderNodeType
  data: IntegrationNodeData
  updateData: (data: Partial<IntegrationNodeData>) => void
}>

const METHODS: HttpMethod[] = ['GET', 'POST', 'PUT', 'DELETE']

export default function IntegrationPropertyPanel({
  id,
  data,
  updateData,
}: IntegrationPropertyPanelProps) {
  const method = useMemo(() => data.method, [data.method])

  return (
    <div className='flex flex-col gap-4 p-4'>
      <div className='-mb-4 self-end text-xs text-card-foreground/20'>{id}</div>

      <div className='grid grid-cols-1 gap-3'>
        <div className='grid grid-cols-1 gap-2 sm:grid-cols-3'>
          <div className='col-span-1'>
            <Label className='mb-1 block text-xs'>Método</Label>
            <Select
              value={method}
              onValueChange={(v: HttpMethod) => updateData({ method: v })}
            >
              <SelectTrigger className='h-8'>
                <SelectValue placeholder='Selecione' />
              </SelectTrigger>
              <SelectContent>
                {METHODS.map((m) => (
                  <SelectItem key={m} value={m}>
                    {m}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
          </div>

          <div className='col-span-1 sm:col-span-2'>
            <Label className='mb-1 block text-xs'>URL</Label>
            <Input
              value={data.url}
              onChange={(e) => updateData({ url: e.target.value })}
              placeholder='https://api.exemplo.com/recurso'
            />
          </div>
        </div>

        <div>
          <Label className='mb-1 block text-xs'>Headers (JSON)</Label>
          <Textarea
            value={JSON.stringify(data.headers ?? {}, null, 2)}
            onChange={(e) => {
              try {
                const parsed = JSON.parse(e.target.value || '{}')
                updateData({ headers: parsed })
              } catch {
                // mantém valor anterior se JSON inválido
              }
            }}
            className='min-h-24'
            placeholder='{"Authorization":"Bearer ..."}'
          />
        </div>

        <div>
          <Label className='mb-1 block text-xs'>Body</Label>
          <Textarea
            value={data.body}
            onChange={(e) => updateData({ body: e.target.value })}
            className='min-h-24'
            placeholder='JSON, XML, texto...'
          />
        </div>
      </div>
    </div>
  )
}
